import { inits } from '@common/models';
import type { Types } from '@common/models';
import type { ReduxState } from '@api-client/redux/store';

export default class ApiState {
  bootOption: Types['BootOption'];
  tuneCh: Types['Ch'];
  rank: Types['Rank'][];
  rankAll: Types['Rank'][];
  posts: Types['Post'][];
  postsTimeline: Types['Post'][];
  postsTimelineStock: Types['Post'][];
  digChs: string[];
  typingUsers: string[];
  logs: string[];
  constructor(reduxState: Partial<ReduxState> = {}) {
    this.bootOption = reduxState.bootOption || inits.bootOption;
    this.tuneCh = reduxState.tuneCh || inits.ch;
    this.rank = reduxState.rank || [];
    this.rankAll = reduxState.rankAll || [];
    this.posts = reduxState.posts || [];
    this.postsTimeline = reduxState.postsTimeline || [];
    this.postsTimelineStock = reduxState.postsTimelineStock || [];
    this.digChs = reduxState.digChs || [];
    this.typingUsers = reduxState.typingUsers || [];
    this.logs = [];
  }
}
